import React from 'react'
import { HashLoader } from 'react-spinners'
export default function Loader() {
  return (
    <div className='w-full h-dvh flex justify-center items-center'>
      <HashLoader color='blue' size={40}/>
    </div>
  )
}
